import React, { Component } from 'react';
import swal from 'sweetalert';

import '../css/load.css';
import "../css/loadManager.css";
import loadsStore from '../../stores/loads-store'
import jumpersStore from "../../stores/jumpers-store";
import AddJumpers from './modals/addJumpers'
import CancelJump from './modals/cancelJump'
import EditableJumper from './modals/editableJumper'
import RemovableJumper from './modals/removableJumper'
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import RenderFunJump from './RenderFunJump';
import RenderTandemJump from './RenderTandemJump';
import RenderCoachJump from './RenderCoachJump';
import RenderAffJump from './RenderAffJump';
import RenderPilotCard from "./RenderPilotCard";
import { DropTarget, DragSource } from 'react-dnd'
import CreateFunJumpCard from './modals/CreateFunJumpCard';
import CreateTeamJumpCard from './modals/CreateTeamJumpCard';

import LoadHeader from './LoadHeader/LoadHeader';
import LoadsFooter from './LoadsFooter';
import Time from '../LoadCallPage/Timer'

var listStyle = { display: 'inline-block', marginRight: '5px', backgroundColor: '#a0c2df', fontSize: '12px', padding: '3px', borderRadius: '5px', marginBottom: '1px' }

const override = `
				display: block;
				margin: 0 auto;
				border-color: red;
				`;

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    // hovered: monitor.isOver(),
    // item: monitor.getItem(),
  }
}


const loadTarget = {
  hover(props, monitor, component) {
    // const dragIndex = monitor.getItem().index
    // const hoverIndex = props.index
  },
  drop(props, monitor, component) {

    if (monitor.didDrop()) {
      // If you want, you can check whether some nested
      // target already handled drop
      return;
    }

    const dragItem = monitor.getItem();
    const hoverItem = props;


    var targetLoad = loadsStore.getLoadNumByIndx(props.loadIndx);

    var loadNum = dragItem.loadNum;
    var jumpId = dragItem.jumpId;
    var jumpType = dragItem.jumpType;
    // Obtain the dragged item

    //////console.log("dragItem 64", dragItem);
    if (dragItem.jumper && dragItem.jumper._id) {
      var jumpBodyN = {
        "jumpType": dragItem.funJump.jumpType,
        "jumperIds": [{
          jumperId: dragItem.jumper._id,
          price: dragItem.jumper.price,
          block: dragItem.jumper.block,
          blockId: dragItem.jumper.blockId,
          gearPrice: dragItem.jumper.gearPrice,
          gearType: dragItem.jumper.gearType,
          isLOing: dragItem.jumper.isLOing,
          tracked: dragItem.jumper.tracked,
          isVideographer: dragItem.jumper.isVideographer
        }],
        "gearRentals": dragItem.jumper.gearRental ? [dragItem.jumper._id] : [],
        "studentgearRentals": dragItem.jumper.studentgearRental ? [dragItem.jumper._id] : [],
        "sportgearRentals": dragItem.jumper.sportgearRental ? [dragItem.jumper._id] : [],
        "pending": false,
        "altitude": dragItem.funJump.altitude
      }

      if (loadNum === targetLoad) {
        jumpBodyN.allowClosedOverride = true;
      }
      if (window.ENV?.disableRemoveAt8MinCall && dragItem.timeRemaining < 480 && loadNum != targetLoad) {
        swal({
          title: "Warning",
          text: "cannot move with less than 5 min call",
          icon: "warning",
          dangerMode: false,
        })
      }
      else {
        loadsStore.createFunJump(targetLoad, jumpBodyN)
          .then(r => {
            if (r) {
              loadsStore.removeJumper(dragItem.loadNum, dragItem.funJump.jumpId, dragItem.jumper._id);
            }
          })
      }

    }
    if (loadNum == targetLoad) {
      // If you want, you can check whether some nested
      // target already handled drop
      return;
    }

    if (dragItem.jumpType === "funJump") {

      var moveJumpType = dragItem.funJump.jumpType;

      var jumperIdArray = [];
      var studentgearRentArray = [];
      var sportgearRentArray = [];

      // var jumperIds= dragItem.funJump.jumpers[0]._id;
      // var gearRentals= dragItem.funJump.jumpers[0].gearRental;

      var jumperIds = dragItem.funJump.jumpers.map(jumper => {
        return {
          jumperId: jumper._id,
          price: jumper.price,
          block: jumper.block,
          blockId: jumper.blockId,
          gearPrice: jumper.gearPrice,
          gearType: jumper.gearType,
          tracked: jumper.tracked,
          isLOing: jumper.isLOing,
          isVideographer: jumper.isVideographer
        };
      });

      var studentgearRentals = dragItem.funJump.studentgearRentals;

      var sportgearRentals = dragItem.funJump.sportgearRentals;

      if (studentgearRentals && studentgearRentals.length > 0) {
        studentgearRentals.forEach(element => {
          if (element != null) {
            studentgearRentArray.push(element);
          }
        })
      }

      if (sportgearRentals && sportgearRentals.length > 0) {
        sportgearRentals.forEach(element => {
          if (element != null) {
            sportgearRentArray.push(element);
          }
        })
      }

      var jumpPostBody = {
        jumpType: moveJumpType,
        jumperIds: jumperIds,
        studentgearRentals: studentgearRentArray,
        sportgearRentals: sportgearRentArray,
        lowPass: dragItem.funJump.lowPass,
        altitude: dragItem.funJump.altitude,
        timeRemaining: dragItem.timeRemaining,
        note: dragItem.funJump.note,
        teamName: dragItem.funJump.teamName,
        teamId: dragItem.funJump.teamId,
        teamType: dragItem.funJump.teamType
      };

      var removeBody = {
        loadNum: loadNum,
        jumpId: jumpId,
        jumpType: jumpType
      }


      //////console.log(jumpPostBody)

      //dragItem.handleCreateFun(targetLoad, jumpPostBody, removeBody);
      dragItem.handleRemoveFun(targetLoad, jumpPostBody, removeBody);
    }
    else if (dragItem.jumpType === "tandemJump") {
      //////console.log("tandemJump");
      var today = new Date();
      var isWeekend = (today.getDay() % 6 === 0);


      var instructor = dragItem.tandemJump.instructor._id;
      var student = dragItem.tandemJump.student._id;
      var videographer = "";
      if (dragItem.tandemJump.videographer != undefined) {
        videographer = dragItem.tandemJump.videographer._id;
      }

      var tandemBody = {
        instructorId: instructor,
        studentId: student,
        isWeekend: isWeekend,
        isUltra: dragItem.tandemJump.isUltra,
        instructorPay: dragItem.tandemJump.instructorPay,
        price: dragItem.tandemJump.price,
        videoPay: dragItem.tandemJump.videoPay,
        wristcamPay: dragItem.tandemJump.wristcamPay,
        videoType: dragItem.tandemJump.videoType,
        videoPrice: dragItem.tandemJump.videoPrice,
        withVideo: dragItem.tandemJump.withVideo,
        tandemPackageId: dragItem.tandemJump.tandemPackageId,
        videoPackageId: dragItem.tandemJump.videoPackageId,
        isOverweight: dragItem.tandemJump.isOverweight,
        overweightPrice: dragItem.tandemJump.overweightPrice,
        overweightPay: dragItem.tandemJump.overweightPay,
        altitude: dragItem.tandemJump.altitude
      };

      if (videographer != "") {
        tandemBody.videographerId = videographer;
      }
      var removeBody = {
        loadNum: loadNum,
        jumpId: jumpId,
        jumpType: jumpType
      }

      dragItem.handleTandemDrop(targetLoad, tandemBody, removeBody);
    }
    else if (dragItem.jumpType === "affJump") {

      var level = dragItem.affJump.level;
      var mainInstructor = "";

      if (dragItem.affJump.mainInstructor != undefined) {
        mainInstructor = dragItem.affJump.mainInstructor._id;
      }
      var student = dragItem.affJump.student._id;
      var secondaryInstructor = "";

      if (dragItem.affJump.secondaryInstructor != undefined) {
        secondaryInstructor = dragItem.affJump.secondaryInstructor._id;
      }

      var videographer = "";
      if (dragItem.affJump.videographer != undefined) {
        videographer = dragItem.affJump.videographer._id;
      }

      jumpPostBody = {
        level: parseInt(level),
        mainInstructorId: mainInstructor,
        studentId: student
      };

      if (secondaryInstructor != "") {
        jumpPostBody.secondaryInstructorId = secondaryInstructor
      }

      if (videographer != "") {
        jumpPostBody.videographerId = videographer
      }

      var removeBody = {
        loadNum: loadNum,
        jumpId: jumpId,
        jumpType: jumpType
      }

      dragItem.handleCreateAff(targetLoad, jumpPostBody, removeBody);
    }
    else if (dragItem.jumpType === "coachJump") {
      //////console.log("coachJump");
      var coachBody = {
        coachId: dragItem.coachJump.coach._id,
        jumperId: dragItem.coachJump.jumper._id,
        isWingsuit: dragItem.coachJump.isWingsuit
      };

      var removeBody = {
        loadNum: loadNum,
        jumpId: jumpId,
        jumpType: jumpType
      }

      dragItem.handleCoachDrop(targetLoad, coachBody, removeBody);
    }
    // You can do something with it
    // ChessActions.movePiece(item.fromPosition, props.position);

    // You can also do nothing and return a drop result,
    // which will be available as monitor.getDropResult()
    // in the drag source's endDrag() method
    // return dragItem.handleJumperDrop(loadNum, jumpId, jumpType);
  }
}

class Load extends Component {

  constructor(props) {
    super(props);
    //////console.log('in Loads consturtor');
    this.state = {
      jumpers: [],
      slotsRemaining: 0,
      load: props.load,
      loadNum: props.loadNum,
      loadIndx: props.loadIndx,
      creatingFunJump: false,
      funJumpType: "Belly",
      scroll: 'down',
      toggleClass: false,
      isJumperRole: false,
      teamsOptions: [],
      teams: [],
    }
    this.scrollTimer = loadsStore.scrollTimer;
    //////console.log("LoadProps:	" + JSON.stringify(this.props.load))
    this.loadEvents = [
      { name: loadsStore.getEventPrefix('cancelCreateJump'), func: this.handleCancelCreateJump },
      { name: loadsStore.getEventPrefix('teamsLoaded'), func: this.handelTeamsLoaded },
      { name: loadsStore.getEventPrefix('updateLoad'), func: this.handleLoadStatusToggleEvent },
      { name: loadsStore.getEventPrefix('updateLoad_' + props.loadNum), func: this.handleUpdateThisLoad },
      { name: loadsStore.getEventPrefix('createLoad_' + props.loadIndx), func: this.handleCreateNewLoad },
      { name: loadsStore.getEventPrefix('cancelLoads'), func: this.handleCancelLoads },
      { name: loadsStore.getEventPrefix('toggleLoadStatus'), func: this.handleLoadStatusToggleEvent },
      { name: loadsStore.getEventPrefix('cancelPreviousJump'), func: this.handlePreviousJump },
    ];
    this.myDivToFocus = React.createRef()
  }

  DeleteJumper = (id) => {
    //////console.log(id);
  }

  handleJumperDrop(loadNum, jumpId, jumpType) {
    //////console.log(JSON.stringify(loadNum));

    //////console.log("load: " + loadNum + " jumpId: " + jumpId);
    if (jumpType === "tandemJump") {
      loadsStore.cancelTandemJump(loadNum, jumpId);
    }
    else if (jumpType === "affJump") {
      loadsStore.cancelAffJump(loadNum, jumpId);
    }
    else if (jumpType === "funJump") {
      loadsStore.cancelFunJump(loadNum, jumpId);
    }
    else if (jumpType === "coachJump") {
      //////console.log('remove coach jump');
      loadsStore.cancelCoachJump(loadNum, jumpId);
    }
  }

  // handleCreateFun(loadNum, jumpBody, removeBody) {
  //     var that = this;
  //     Promise.all([loadsStore.createFunJump(loadNum, jumpBody)])
  //         .then(function (result) {
  //             //////console.log(result);
  //             if (result[0] === true) {
  //                 //////console.log(JSON.stringify(loadNum));
  //                 var loadNum = removeBody.loadNum;
  //                 var jumpId = removeBody.jumpId;
  //                 var jumpType = removeBody.jumpType;

  //                 that.handleJumperDrop(loadNum, jumpId, jumpType);

  //             }
  //         })
  // }


  handleCreateFun(loadNum, jumpBody) {
    var that = this;
    loadsStore.createFunJump(loadNum, jumpBody)
      .then(function (result) {
        if (result[0] === true) {
          //////console.log(result[0]);
        }
      })
  }

  handleRemoveFun(loadNum, jumpBody, removeBody) {
    var that = this;
    var removeloadNum = removeBody.loadNum;
    var newLoadNum = loadNum;
    var jumpId = removeBody.jumpId;
    var jumpType = removeBody.jumpType;
    if (window.ENV?.disableRemoveAt8MinCall && jumpBody.timeRemaining < 480) {
      swal({
        title: "Warning",
        text: "cannot move with less than 8 min call",
        icon: "warning",
        dangerMode: false,
      })
    }
    else {
      loadsStore.createFunJump(loadNum, jumpBody)
        .then(result => {
          if (result === true) {
            loadsStore.cancelFunJump(removeloadNum, jumpId)
          }
        })
    }
  }

  handleCreateAff(loadNum, affPostBody, removeBody) {
    //loadsStore.createAffJump(loadNum, affPostBody);
    var that = this;
    Promise.all([loadsStore.createAffJump(loadNum, affPostBody)])
      .then(function (result) {
        //////console.log(result);
        if (result[0] === true) {
          //////console.log(JSON.stringify(loadNum));
          var loadNum = removeBody.loadNum;
          var jumpId = removeBody.jumpId;
          var jumpType = removeBody.jumpType;

          that.handleJumperDrop(loadNum, jumpId, jumpType);

        }
      })
  }

  handleCoachDrop(loadNum, coachBody, removeBody) {
    // loadsStore.createCoachJump(loadNum, coachBody)
    var that = this;
    Promise.all([loadsStore.createCoachJump(loadNum, coachBody)])
      .then(function (result) {
        //////console.log(result);
        if (result[0] === true) {
          //////console.log(JSON.stringify(loadNum));
          var loadNum = removeBody.loadNum;
          var jumpId = removeBody.jumpId;
          var jumpType = removeBody.jumpType;

          that.handleJumperDrop(loadNum, jumpId, jumpType);
        }
      })
  }

  handleTandemDrop(loadNum, tandemBody, removeBody) {
    // loadsStore.createTandemJump(loadNum,tandemBody);
    var that = this;
    Promise.all([loadsStore.createTandemJump(loadNum, tandemBody)])
      .then(function (result) {
        //////console.log(result);
        if (result[0] === true) {
          //////console.log(JSON.stringify(loadNum));
          var loadNum = removeBody.loadNum;
          var jumpId = removeBody.jumpId;
          var jumpType = removeBody.jumpType;

          that.handleJumperDrop(loadNum, jumpId, jumpType);
        }
      })
  }


  componentWillMount = () => {
    this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func))
    document.querySelector('body').addEventListener("click", this.handleEventClick, false);
    document.addEventListener("click", this.handleClickOutside, true);
    // loadsStore.loadTeams()
  }

  componentDidMount = () => {
    //console.log('component did mount');
    this.setJumperRole();
    //console.log('load indx');
    //console.log(this.props.loadIndx)
    if (localStorage.getItem("displayOnly") !== null) {
      var displayValue = localStorage.getItem("displayOnly");
      var role = localStorage.getItem("role");
      if (displayValue === "true" && role != 'pilot' && role != 'video edit') {
        loadsStore.displayOnly = true
        this.handleScroll();
      }
      else {
        if (displayValue === "true") {
          loadsStore.displayOnly = true
        } else {
          loadsStore.displayOnly = false
        }
        this.cancelScroll();
      }
    }
  }

  /*
  componentDidUpdate = () => {

    //console.log('component did update');
    this.cancelScroll();
    if (localStorage.getItem("displayOnly") !== null) {
      var displayValue = localStorage.getItem("displayOnly");
      var role = localStorage.getItem("role");
      if (displayValue === "true" && role != 'pilot' && role != 'video edit') {
        loadsStore.displayOnly = true
        this.handleScroll();
      }
      else {
        if (displayValue === "true") {
          loadsStore.displayOnly = true
        } else {
          loadsStore.displayOnly = false
        }
        this.cancelScroll();
      }
    }
  }
  */
  componentWillUnmount = () => {
    this.cancelScroll();
    this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));
    document.querySelector('body').removeEventListener("click", this.handleEventClick, false);

    document.removeEventListener("click", this.handleClickOutside, true);

  }

  handleCancelLoads = () => {
    //alert('in handle cancel loads load manager');
    //console.log("in handle cancel loads");
    //console.log(this.props.load);
    this.setState({ load: this.props.load })
  }
  setJumperRole = () => {
    let userRole = localStorage.getItem("role");
    if (userRole && userRole === "jumper") {
      this.setState({ isJumperRole: true })
    }
  }
  handleEventClick = () => {
    var divsToHide = document.getElementsByClassName("pastepanel");
    for (var i = 0; i < divsToHide.length; i++) {
      divsToHide[i].style.display = "none";
    }
  }
  setJumpers = (load) => {
    var numJumpers = 0;
    this.setState({
      slotsRemaining: 25 - load.totalJumpers
    })
  }
  handleScroll = () => {
    var scroll = 'down'
    this.scrollTimer = setInterval(function () {
      ////console.log("scrollTime: ");
      if (scroll == 'down') {
        let element = document.getElementsByClassName('centercard')
        for (let i = 0; i < element.length; i++) {
          element[i].scrollTop = element[i].scrollHeight;
        }
        scroll = 'up'
      }
      else {
        let element = document.getElementsByClassName('centercard')
        for (let i = 0; i < element.length; i++) {
          element[i].scrollTop = 0;
        }
        scroll = 'down'
      }
    }, 6000)
  }

  cancelScroll = () => {
    clearInterval(this.scrollTimer);
  }



  toggleLoadStatus(closed) {
    if (closed) {
      loadsStore.openLoad(this.state.load.loadNum);
    }
    else {
      loadsStore.closeLoad(this.state.load.loadNum);
    }
  }

  handelTeamsLoaded = (teams) => {
    let teamsOptions = teams.map(ele => {
      let newObj = {}
      newObj.label = ele.firstname;
      newObj.value = ele;
      return newObj;
    })
    this.setState({ teams, teamsOptions })
  }

  handleCancelCreateJump = (loadNum) => {
    let loadNo
    if (loadNum.type === "teamjump") {
      loadNo = loadNum.loadNum
    } else {
      loadNo = loadNum
    }
    if (this.state.load.loadNum === loadNo) {
      this.setState({ creatingFunJump: false, creatingTeamJump: false });
    }
  }

  handlePreviousJump = (loadNum) => {
    if (this.state.load.loadNum !== loadNum && this.state.creatingFunJump === true) {
      this.setState({ creatingFunJump: false });
    }
  }

  handleLoadStatusToggleEvent = (load) => {

    this.setState({
      load: load
    });

    if (load.closed) {
      this.setState({
        background: '#a4abad'
      });
    }
    else {
      this.setState({
        background: '#e7f2f6'
      });
    }
  }

  removeFunJumper = (loadNum, jumpId, jumperId) => {
    loadsStore.removeJumper(loadNum, jumpId, jumperId);
  }

  // RenderFunJump = ({ funJump, loadNum, jumpId, disabled, jumperOptions }) => {

  //     const jumpers = funJump.jumpers.map((jumper) => {
  //         return (
  //             // <li key={jumper._id} style={listStyle} >
  //             <ul className="jumper-load">
  //                 <li key={jumper._id}>
  //                     <RemovableJumper loadNum={loadNum} jumpId={jumpId} jumper={jumper} />
  //                 </li>
  //             </ul>
  //         );
  //     })

  //     return (
  //         <Card className="jumpcard">
  //             <CardHeader className="jumpcardheader align-items-center row">
  //                 <div className="col-2">
  //                     {["HopNPop", "Solo", "High Pull"].indexOf(funJump.jumpType) >= 0 ? null : <AddJumpers loadNum={loadNum} jumpId={jumpId} disabled={disabled} jumperOptions={jumperOptions} />}
  //                 </div>
  //                 <div className="col-8">
  //                     {funJump.jumpType}
  //                 </div>
  //                 <div className="col-2">
  //                     <CancelJump loadNum={loadNum} jumpId={jumpId} jumpType={"funJump"} />
  //                 </div>
  //             </CardHeader>
  //             <CardBody className="custom-card-body" style={{ padding: '10px' }}>
  //                 {/* <ul className="list-unstyled"> */}
  //                 {jumpers}
  //                 {/* </ul> */}
  //             </CardBody>
  //         </Card>
  //     );
  // }
  handleUpdateThisLoad = (load) => {
    this.setState({ load: load });
  }
  handleCreateNewLoad = (load) => {
    //alert('create new load');
    //console.log('handle create new load');
    //console.log(load.loadNum);
    //console.log(load);

    this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));

    this.setState({
      key: load.key ? load.key : null,
      load: load,
      loadNum: load.loadNum ? load.loadNum : null
    });


    this.loadEvents = [
      { name: loadsStore.getEventPrefix('cancelCreateJump'), func: this.handleCancelCreateJump },
      { name: loadsStore.getEventPrefix('updateLoad'), func: this.handleLoadStatusToggleEvent },
      { name: loadsStore.getEventPrefix('createLoad_' + this.props.loadIndx), func: this.handleCreateNewLoad },
      { name: loadsStore.getEventPrefix('cancelLoads'), func: this.handleCancelLoads },
      { name: loadsStore.getEventPrefix('toggleLoadStatus'), func: this.handleLoadStatusToggleEvent },
      { name: loadsStore.getEventPrefix('cancelPreviousJump'), func: this.handlePreviousJump },
    ];
    if (load.loadNum) {
      this.loadEvents.push({ name: loadsStore.getEventPrefix('updateLoad_' + load.loadNum), func: this.handleUpdateThisLoad });
    }
    this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func))
  }
  createTeamJump = (id, jumpType) => {

    let { toggleClass } = this.state
    this.setState({ creatingTeamJump: true }
      , () => {
        loadsStore.cancelPreviousJump(this.state.load.loadNum)
        // var objDiv = document.getElementById(id);
        // objDiv.scrollTop = objDiv.scrollHeight;
      });
    loadsStore.setEdit();
  }

  createFunJump = (id, jumpType) => {
    // this.setState({ creatingFunJump: true });

    let { toggleClass } = this.state
    this.setState({ creatingFunJump: true, funJumpType: jumpType, toggleClass: !toggleClass }
      , () => {
        loadsStore.cancelPreviousJump(this.state.load.loadNum)
        var objDiv = document.getElementById(id);
        objDiv.scrollTop = objDiv.scrollHeight;

        // setTimeout(objDiv.scrollTo(400,400),100);
        // objDiv.scrollTo += 500

        // objDiv.scrollTo(400,400)

        // if(navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        //   // window.scrollTop(0)
        //       alert(true)
        //     document.getElementById(id).scrollIntoView();
        //   window.scrollTop(0)

        //   } else {
        //     alert(false)

        //       // default `$('html,body')` code for scrolling
        //   }

      });
    loadsStore.setEdit();
  }


  createCoachJump = () => {
    //alert("loadNum: " + loadNum);
    loadsStore.createCoachJump(this.state.load.loadNum, {});
  };

  createWingsuitCoachJump = () => {
    //alert("loadNum: " + loadNum);
    loadsStore.createCoachJump(this.state.load.loadNum, { isWingsuit: true });
    // loadsStore.createCoachJump(this.state.load.loadNum, {});
  };

  createAffJump = (type) => {
    //alert("loadNum: " + loadNum);
    var postBody = { type: type };

    postBody.studentPackageId = loadsStore.getDefaultStudentPackageId(type);

    loadsStore.createAffJump(this.state.load.loadNum, postBody);
  };



  createTandemJump = (e) => {
    var loadNum = e.target.getAttribute('data-key');
    var today = new Date();
    var isWeekend = (today.getDay() % 6 === 0)
    loadsStore.createTandemJump(loadNum, { isWeekend: isWeekend });
    // loadsStore.createTandemJump(this.state.load.loadNum, {isWeekend: isWeekend});
  }
  handlePasteClick = (loadNum, uid) => {
    //////console.log('pasteclicked', loadNum);
    var Value = loadsStore.copyValue;
    loadsStore.createFunJump(loadNum, Value).then(d => {
      ////console.log("createFunJump in pasted", d)
      if (d) {
        if (loadsStore.cut) {
          loadsStore.cut = false
          const { loadNum, jumpId } = loadsStore.cutValue
          loadsStore.cancelFunJump(loadNum, jumpId)
        }
      }
    })
    var element = document.getElementById(uid);
    // element.style.display = "none";
  }
  toggleFooterClass = () => {
    this.setState({ toggleClass: !this.state.toggleClass })
  }
  handleClick = (e, uid, parentId) => {
    if (!this.props.iscompleted) {
      e.preventDefault();
      var divsToHide = document.getElementsByClassName("pastepanel");
      for (var i = 0; i < divsToHide.length; i++) {
        divsToHide[i].style.display = "none";
      }

      var element = document.getElementById(uid);
      // element.style.right = e.clientX - 238  + "px";
      // element.style.top = "38px"; //e.clientY + "px";
      element.style.display = "block";
      // setTimeout(() => {
      //     element.style.display = "none";
      // }, 10000)

      var container = document.getElementById(parentId);//document.querySelector("#contentContainer");

      var xPosition = e.clientX - container.getBoundingClientRect().left - (element.clientWidth / 2);
      var yPosition = (e.clientY - container.getBoundingClientRect().top - (element.clientHeight / 2) - 115);
      element.style.left = xPosition + "px";
      element.style.top = yPosition + "px";
    }
  }
  RenderAltGroup = (props) => {
    if (Object.getOwnPropertyNames(this.state.load).length === 0) {
      return <div className="col" style={{ padding: "0px !important" }}></div>;
    }
    else {
      // //console.log("RenderAltGroup: ", this.props.tandemInstructorOptions);


      const tandemJumps = props.tandemJumps
        .filter(jump => !jump.isUltra)
        .map((tandemJump, i) => {
          return (
            <CSSTransition key={i} timeout={500} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderTandemJump
                  history={this.props.history}
                  id={"tandem" + i}
                  key={i}
                  tandemJump={tandemJump}
                  load={this.state.load}
                  loads={this.props.loads}
                  loadNum={this.state.load.loadNum}
                  jumpId={tandemJump.jumpId}
                  jumpType="tandemJump"
                  price={tandemJump.price}
                  isJumperRole={this.state.isJumperRole}
                  isCompleted={this.props.iscompleted}
                  handleJumperDrop={this.handleJumperDrop}
                  handleTandemDrop={this.handleTandemDrop}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const affJumps = props.affJumps.map((affJump, i) => {
        return (
          <CSSTransition key={i} timeout={700} classNames="fade">
            <div id={i} key={i} className="col-12">
              <RenderAffJump
                history={this.props.history}
                id={"Coach" + i}
                key={i}
                affJump={affJump}
                loadNum={this.state.load.loadNum}
                jumpId={affJump.jumpId}
                jumpType="affJump"
                price={affJump.price}
                handleJumperDrop={this.handleJumperDrop}
                handleCreateAff={this.handleCreateAff}
                isCompleted={this.props.iscompleted}
                loads={this.props.loads}
                load={this.state.load}
                isJumperRole={this.state.isJumperRole}
                loadsToShow={props.loadsToShow}
                fontSize={props.fontSize}
                columnsPerGroup={props.columnsPerGroup}
              />
            </div>
          </CSSTransition>
        );
      });

      const coachJumps = props.coachJumps
        .filter(jump => jump.isWingsuit !== true)
        .map((coachJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderCoachJump
                  id={"Coach" + i}
                  history={this.props.history}
                  key={i}
                  coachJump={coachJump}
                  loadNum={this.state.load.loadNum}
                  jumpId={coachJump.jumpId}
                  jumpType="coachJump"
                  price={coachJump.price}
                  handleJumperDrop={this.handleJumperDrop}
                  handleCoachDrop={this.handleCoachDrop}
                  isCompleted={this.props.iscompleted}
                  loads={this.props.loads}
                  load={this.state.load}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const wingsuitCoachJumps = props.coachJumps
        .filter(jump => jump.isWingsuit)
        .map((coachJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderCoachJump
                  id={"Coach" + i}
                  history={this.props.history}
                  key={i}
                  loadNum={this.state.load.loadNum}
                  jumpId={coachJump.jumpId}
                  jumpType="coachJump"
                  price={coachJump.price}
                  handleJumperDrop={this.handleJumperDrop}
                  handleCoachDrop={this.handleCoachDrop}
                  isCompleted={this.props.iscompleted}
                  loads={this.props.loads}
                  load={this.state.load}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const wingSuitJumps = props.funJumps
        .filter(jump => jump.jumpType === "Wingsuit")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}

                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const crwJumps = props.funJumps
        .filter(jump => jump.jumpType === "CRW")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}

                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const tandemPracticeJumps = props.funJumps
        .filter(jump => jump.jumpType === "Tandem Practice")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}

                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const xrwJumps = props.funJumps
        .filter(jump => jump.jumpType === "XRW")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const wrangleJumps = props.funJumps
        .filter(jump => jump.jumpType === "WRAngle")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const bellyJumpsSolo = props.funJumps
        .filter(
          jump =>
            jump.jumpType === "Belly" &&
            jump.jumpers.length === 1
        )
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          //alert("rendering belly");
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const bellyJumps = props.funJumps
        .filter(
          jump =>
            jump.jumpType === "Belly" &&
            jump.jumpers.length > 1
        )
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          //alert("rendering belly");
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });
      const hybridJumps = props.funJumps
        .filter(jump => jump.jumpType === "Hybrid")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const freeflyJumps = props.funJumps
        .filter(jump => jump.jumpType === "Freefly")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });
      const freeflyAndAngleJumps = props.funJumps
        .filter(jump => jump.jumpType === "Freefly" || jump.jumpType === "Angle")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const hopnpops = props.funJumps
        .filter(
          jump =>
            jump.jumpType === "HopNPop" || jump.jumpType === "HopNPop Student"
        )
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const solos = props.funJumps
        .filter(jump => jump.jumpType === "Solo Student")
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const highpulls = props.funJumps
        .filter(jump => jump.jumpType === "High Pull")
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const trackingJumps = props.funJumps
        .filter(jump => jump.jumpType === "Tracking" && !jump.trackingFirstOut)
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  toggleToster={this.toggleToster}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const trackingJumpsFirstOut = props.funJumps
        .filter(jump => jump.jumpType === "Tracking" && jump.trackingFirstOut)
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  toggleToster={this.toggleToster}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });
      const angleTrack = props.funJumps
        .filter(jump => jump.jumpType === "Angle")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  toggleToster={this.toggleToster}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const speed = props.funJumps
        .filter(jump => jump.jumpType === "Speed")
        .sort((a, b) => {
          return a.jumpers.length - b.jumpers.length;
        })
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  toggleToster={this.toggleToster}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  load={this.state.load}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      const undecidedJumps = props.funJumps
        .filter(jump => jump.jumpType === "Undecided")
        .map((funJump, i) => {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={funJump}
                  loadNum={this.state.load.loadNum}
                  timeRemaining={this.state.load.timeRemaining}
                  load={this.state.load}
                  disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers}
                  jumpId={funJump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  isCompleted={this.props.iscompleted}
                  isJumperRole={this.state.isJumperRole}
                  loadsToShow={props.loadsToShow}
                  fontSize={props.fontSize}
                  columnsPerGroup={props.columnsPerGroup}
                />
              </div>
            </CSSTransition>
          );
        });

      var IsEventEnable = this.props.isCompleted ? "none" : "";

      return (
        <React.Fragment>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {xrwJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {crwJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {highpulls}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {wingsuitCoachJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {wrangleJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {wingSuitJumps}
            </TransitionGroup>
          </div>



          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {trackingJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {tandemPracticeJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {tandemJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {affJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {solos}
            </TransitionGroup>
          </div>


          {window.ENV?.arizona ?
            <div
              className="row"
              style={{ pointerEvents: IsEventEnable }}
            >
              <TransitionGroup style={{ width: "100%" }}>
                {freeflyAndAngleJumps}
              </TransitionGroup>
            </div>
            :
            <div
              className="row"
              style={{ pointerEvents: IsEventEnable }}
            >
              <TransitionGroup style={{ width: "100%" }}>
                {freeflyJumps}
              </TransitionGroup>
            </div>
          }

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {hybridJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {bellyJumpsSolo}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {coachJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {bellyJumps}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {trackingJumpsFirstOut}
            </TransitionGroup>
          </div>

          {window.ENV?.arizona !== true ?
            <div
              className="row"
              style={{ pointerEvents: IsEventEnable }}
            >
              <TransitionGroup style={{ width: "100%" }}>
                {angleTrack}
              </TransitionGroup>
            </div>
            : null
          }
          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {speed}
            </TransitionGroup>
          </div>

          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {hopnpops}
            </TransitionGroup>
          </div>
          <div
            className="row"
            style={{ pointerEvents: IsEventEnable }}
          >
            <TransitionGroup style={{ width: "100%" }}>
              {undecidedJumps}
            </TransitionGroup>
          </div>
        </React.Fragment>)
    }
  }
  setHeaderMenuRef = node => {
    this.headerMenuRef = node;
  };

  handleClickOutside = event => {
    if (this.headerMenuRef && !this.headerMenuRef.contains(event.target)) {
      this.setState({
        headerMenu: false
      });
    }
  };
  handleLongName = (longStr) => {
    // longStr=longStr+"DFFDF FD"
    if (longStr.length > 20) {
      return <span className="plane-smalltext">NEXT {longStr.slice(0, 20).toUpperCase()}</span>

    }
    else if (longStr.length > 10) {
      return <span className="plane-smalltext">NEXT {longStr.toUpperCase()}</span>
    }
    else {
      return <span className="plane-text">NEXT {longStr.toUpperCase()}</span>
    }
  }
  returnColSize = () => {
    let { loadsToShow } = this.props;
    let screenWidth = window.innerWidth;
    if (screenWidth >= 1400) {
      if (loadsToShow >= 5) {
        return 'col-md-2';
      } else if (loadsToShow === 4) {
        return 'col-md-3'
      }
      else if (loadsToShow === 3) {
        return 'col-md-4'
      }
      else {
        return 'col-md-6';
      }
    }
    else if (screenWidth >= 992) {
      return 'col-md-4'
    }
    else if (screenWidth >= 500) {
      return 'col-md-6'
    }
    else {
      return 'col-md-10'
    }
  }
  render() {
    console.log('rendering loadIndx: ' + this.props.loadIndx);
    //console.log('in render load component');
    //console.log(this.props.load);
    //console.log(this.state.load);
    var role = localStorage.getItem("role");
    var IsdisplayOnly = loadsStore.displayOnly ? 'none' : '';

    var IsEventEnable = this.props.iscompleted ? 'none' : '';

    var colsize = this.returnColSize();

    //////console.log(this.props.load);
    // alert(JSON.stringify("rendering load"+ JSON.stringify(this.props.load)));
    if (Object.getOwnPropertyNames(this.state.load).length === 0) {
      return (
        <div className="col" style={{ padding: '0px !important' }}>
        </div>
      );
    }
    else {

      if (!this.props.iscompleted) {
        var tandemInstructorOptions = this.props.tandemInstructorOptions ? this.props.tandemInstructorOptions.filter(option => this.state.load.activeJumperIds.findIndex(id => option.value._id === id) === -1) : [];
        var affInstructorOptions = this.props.affInstructorOptions ? this.props.affInstructorOptions.filter(option => this.state.load.activeJumperIds.findIndex(id => option.value._id === id) === -1) : [];
        var affStudentOptions = this.props.affStudentOptions ? this.props.affStudentOptions.filter(option => this.state.load.activeJumperIds.findIndex(id => option.value._id === id) === -1) : [];
        var videographerOptions = this.props.videographerOptions ? this.props.videographerOptions.filter(option => this.state.load.activeJumperIds.findIndex(id => option.value._id === id) === -1) : [];
        var jumperOptions = this.props.jumperOptions ? this.props.jumperOptions.filter(option => this.state.load.activeJumperIds.findIndex(id => option.value._id === id) === -1) : [];
        var coachOptions = this.props.coachOptions ? this.props.coachOptions.filter(option => this.state.load.activeJumperIds.findIndex(id => option.value._id === id) === -1) : [];
        var tandemStudentOptions = this.props.tandemStudentOptions ? this.props.tandemStudentOptions.map(option => { return { label: option.label, value: option.value } }) : []
        var pilotOptions = jumpersStore.getPilotOptions().filter(
          option =>
            this.state.load.activeJumperIds.findIndex(
              id => option.value._id === id
            ) === -1
        );
      }
      else {
        var tandemInstructorOptions = this.props.tandemInstructorOptions;
        var affInstructorOptions = this.props.affInstructorOptions;
        var affStudentOptions = this.props.affStudentOptions;
        var videographerOptions = this.props.videographerOptions;
        var jumperOptions = this.props.jumperOptions;
        var coachOptions = this.props.coachOptions;
        var pilotOptions = jumpersStore.getPilotOptions().filter(
          option =>
            this.state.load.activeJumperIds.findIndex(
              id => option.value._id === id
            ) === -1
        );
        var tandemStudentOptions = this.props.tandemStudentOptions.map(option => { return { label: option.label, value: option.value } })
      }

      //alert(JSON.stringify(tandemStudentOptions));
      //alert("line 599: " + JSON.stringify(tandemStudentOptions));
      ////console.log(affStudentOptions);
      var altitudes = loadsStore.getAltitudes();

      var jumpsByAltitude = altitudes.map((altitude, idx) => {
        var tandemJumps = this.state.load.tandemJumps.filter(jump => altitude.name === jump.altitude);
        var affJumps = this.state.load.affJumps.filter(jump => altitude.name === jump.altitude);
        var coachJumps = this.state.load.coachJumps.filter(jump => altitude.name === jump.altitude);
        var funJumps = this.state.load.funJumps.filter(jump => altitude.name === jump.altitude);
        return (
          <this.RenderAltGroup
            key={idx}
            tandemJumps={tandemJumps}
            affJumps={affJumps}
            coachJumps={coachJumps}
            funJumps={funJumps}
            loadsToShow={this.props.loadsToShow}
            fontSize={this.props.fontSize}
            columnsPerGroup={this.props.columnsPerGroup}
          />
        )
      })
      const alljumps = this.state.load?.alljumps?.map((jump, i) => {
        console.log('rendering all jumps');
        console.log(jump);
        if (jump.superType === "tandem") {
          return (
            <CSSTransition key={i} timeout={500} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderTandemJump
                  history={this.props.history}
                  id={"tandem" + i}
                  key={i}
                  tandemJump={jump}
                  load={this.state.load}
                  loads={this.props.loads}
                  loadNum={this.state.load.loadNum}
                  jumpId={jump.jumpId}
                  callRequest={jump.callRequest}
                  schoolWaitlist={true}
                  jumpType="tandemJump"
                  discountValue={0}
                  price={jump.price}
                  isCompleted={this.props.iscompleted}
                  handleJumperDrop={this.handleJumperDrop}
                  handleTandemDrop={this.handleTandemDrop}
                  isRightMenu={this.props.isRightMenu}
                  isCenter={this.props.isCenter}
                  loadsToShow={this.props.loadsToShow}
                  columnsPerGroup={this.props.columnsPerGroup}
                  fontSize={this.props.fontSize}
                  isInline={this.props.isInline}
                // setDragabble={this.handleDragabble}
                // dragabbleItems={loadsStore.getDraggable()}
                // clearItemSelection={this.clearDraggableItems}
                />
              </div>
            </CSSTransition>
          );
        }
        else if (jump.superType == "student") {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderAffJump
                  history={this.props.history}
                  id={"Coach" + i}
                  key={i}
                  affJump={jump}
                  loadNum={this.state.load.loadNum}
                  load={this.state.load}
                  jumpId={jump.jumpId}
                  callRequest={jump.callRequest}
                  schoolWaitlist={true}
                  jumpType="affJump"
                  price={jump.price}
                  handleJumperDrop={this.handleJumperDrop}
                  handleCreateAff={this.handleCreateAff}
                  isCompleted={false}
                  loads={this.props.loads}
                  isRightMenu={this.props.isRightMenu}
                  isCenter={this.props.isCenter}
                  loadsToShow={this.props.loadsToShow}
                  columnsPerGroup={this.props.columnsPerGroup}
                  fontSize={this.props.fontSize}
                  isInline={this.props.isInline}
                // setDragabble={this.handleDragabble}
                // dragabbleItems={this.state.dragabbleItems}
                // clearItemSelection={this.clearDraggableItems}
                />
              </div>
            </CSSTransition>
          );
        }
        else if (jump.superType === "coach") {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderCoachJump
                  id={"Coach" + i}
                  history={this.props.history}
                  key={i}
                  coachJump={jump}
                  loadNum={this.state.load.loadNum}
                  jumpId={jump.jumpId}
                  callRequest={jump.callRequest}
                  schoolWaitlist={true}
                  jumpType="coachJump"
                  price={jump.price}
                  handleJumperDrop={this.handleJumperDrop}
                  handleCoachDrop={this.handleCoachDrop}
                  isCompleted={false}
                  loads={this.props.loads}
                  isRightMenu={this.props.isRightMenu}
                  loadsToShow={this.props.loadsToShow}
                  columnsPerGroup={this.props.columnsPerGroup}
                  fontSize={this.props.fontSize}
                  load={this.state.load}
                  isInline={this.props.isInline}
                />
              </div>
            </CSSTransition>
          );
        }
        else {
          return (
            <CSSTransition key={i} timeout={700} classNames="fade">
              <div id={i} key={i} className="col-12">
                <RenderFunJump
                  id={"wing" + i}
                  key={i}
                  funJump={jump}
                  loadNum={this.state.load.loadNum}
                  disabled={this.state.load.closed}
                  jumpId={jump.jumpId}
                  jumpType="funJump"
                  handleRemoveFun={this.handleRemoveFun}
                  handleCreateFun={this.handleCreateFun}
                  loads={this.props.loads}
                  columnsPerGroup={this.props.columnsPerGroup}
                  fontSize={this.props.fontSize}
                  isInline={this.props.isInline}
                  load={this.state.load}
                  loadsToShow={this.props.loadsToShow}
                />
              </div>
            </CSSTransition>
          )
        }
      })
      const allFunJumps = this.state.load.funJumps.map((funJump, i) => {
        return (
          <CSSTransition
            key={i}
            timeout={700}
            classNames="fade"
          >
            {/* <div key={i} className="col-12 ">
                                <this.RenderFunJump funJump={funJump} loadNum={this.state.load.loadNum} disabled={this.state.load.closed} jumpId={funJump.jumpId} jumperOptions={jumperOptions} />
                            </div> */}
            <div id={i} key={i} className="col-12" >
              <RenderFunJump isCompleted={this.props.iscompleted} id={"wing" + i} key={i} funJump={funJump} loadNum={this.state.load.loadNum}
                timeRemaining={this.state.load.timeRemaining} disabled={this.state.load.closed || this.state.load.capacity === this.state.load.totalJumpers} jumpId={funJump.jumpId} jumpType="funJump" jumperOptions={jumperOptions}

                // handleDrop={(data) => this.handleJumperDrop(data.loadNum, data.jumpId, "funJump")}
                handleRemoveFun={this.handleRemoveFun} handleCreateFun={this.handleCreateFun} isClosed={funJump.isClosed}
                loads={this.props.loads}

              />
            </div>
          </CSSTransition>
        );
      });

      var backgroundColor = "#e7f2f6";
      var backgroundColorHeader = "#1C6CFF";
      var backgroundColorFooter = "#18191D";

      var backgroundDivColor = '#e7f2f6';

      if (this.state.load.waitFuel) {
        backgroundColorHeader = "#b7410e";
        // backgroundColorFooter = "#b7410e";
      }

      if (this.state.load.closed || this.state.load.totalJumpers >= this.state.load.capacity) {
        backgroundColor = "#a4abad";
        backgroundColorHeader = "#1C6BCF";
        // backgroundColorFooter = "#1C6BCF";
      }
      if (this.props.iscompleted) {
        backgroundColor = "#a4abad";
      }
      else if (this.state.load.isWaitlist) {
        backgroundColor = "#4422ee";
      }
      else if (this.state.load.groupId !== undefined) {
        backgroundColor = "#a4abda";
      }

      const { connectDropTarget, hovered, item } = this.props;
      var uid = "load" + this.state.load.loadNum;

      var loadClass = "";
      var loadFooterClass = "centerDivFooter";

      if (this.state.load.gearUp) {
        loadClass += "fe-pulse";
        // loadFooterClass += "fe-pulse";
      }
      var isfull = this.state.load.totalJumpers >= this.state.load.capacity

      var loadNumPrint = this.state.load.loadNum > 0 ? this.state.load.loadNum : "";

      var studentPackageTypes = loadsStore.getStudentPackageTypes();

      var createStudentButtons = studentPackageTypes.map((p, i) => {
        var affSelfManifestSetting = loadsStore.getAffSelfManifestSetting()?.value;
        //alert(affSelfManifestSetting);
        if (affSelfManifestSetting === "yes") {
          if (p === "IAD") {
            return (
              <div
                key={`${i}_createStudentButtons`}
                className="jump-create"
                onClick={() => this.createIadJump(p)}
                disabled={this.props.disabled}
              >
                <i className="fa fa-plus" /> <strong>{p?.toUpperCase()}</strong>
              </div>
            );
          }
          else {
            return (
              <div
                key={`${i}_createStudentButtons`}
                className="jump-create"
                onClick={() => this.createAffJump(p)}
                disabled={this.props.disabled}
              >
                <i className="fa fa-plus" /> <strong>{p?.toUpperCase()}</strong>
              </div>
            );
          }

        }
      });

      let centercard = 'centercard'
      if (this.props.iscompleted) {
        centercard = centercard + " " + 'completed'
      }
      centercard = this.props.iscompleted ? 'centercard-complete' : 'centercard'
      return connectDropTarget(
        // <div key={this.state.load.loadNum} className={colsize + ' load-' + this.state.load.loadNum} style={{ padding: '0px !important' }} id={"Load_" + this.state.load.loadNum + "_Report"}>
        //     <ReactCSSTransitionGroup transitionName="load-manger" transitionAppear={true} transitionEnterTimeout={500} transitionAppearTimeout={500} transitionLeave={true} transitionLeaveTimeout={1000}>
        //         <div className={loadClass} onContextMenu={(e) => this.handleClick(e, uid, "Load_" + this.state.load.loadNum + "_Report")}>
        //             <div className="centerCards" style={{ background: backgroundColor, overflow: 'hidden', marginTop: '3%', height: '80vh' }} >
        //                 <div className="centerDivHeading row" style={{ background: backgroundColorHeader }} >
        //                     <div className="col-12" style={{ fontSize: '1.2rem !important' }}>
        //                         <div style={{ fontSize: '24px' }} ><strong> <span style={{ fontSize: '34px' }}>LOAD {this.state.load.loadNum} </span>  - {this.state.load.plane.toUpperCase()}-{this.state.load.planeLoadNum}</strong></div>
        //                         <span style={{ fontSize: '18px', backgroundColor: '#1b5ba1' }} className="badge">
        //                             jumpers manifested: {this.state.load.totalJumpers} out of {this.state.load.capacity}
        //                         </span>
        //                         {
        //                             this.props.iscompleted ? <span style={{ fontSize: '18px' }} className="badge">COMPLETED</span> : null
        //                         }
        //                         {
        //                             !this.props.iscompleted && this.state.load.closed ? <span style={{ fontSize: '18px' }} className="badge">CLOSED</span> : null
        //                         }
        //                         {
        //                             !this.props.iscompleted && this.state.load.gearUp ? <span className="badge" style={{ backgroundColor: '#464123', fontSize: '18px' }} >GEAR UP</span> : null
        //                         }
        //                         {
        //                             !this.props.iscompleted && !this.state.load.gearUp && this.state.load.isNext ? <span className="badge" style={{ backgroundColor: '#008000', fontSize: '18px' }} >NEXT LOAD</span> : null
        //                         }
        //                         {
        //                             !this.props.iscompleted && !this.state.load.gearUp && this.state.load.waitFuel ? <span className="badge" style={{ backgroundColor: '#464123', fontSize: '18px' }} >FUEL BEFORE</span> : null
        //                         }
        //                         {
        //                             !this.props.iscompleted && this.state.load.reserved ? <span className="badge" style={{ backgroundColor: '#FFA500', fontSize: '18px' }} >RESERVED</span> : null
        //                         }

        //                     </div>
        //                 </div>
        //                 <div className="row">
        //                     <div className="col-12">
        //                         <div className="react-contextmenu pastepanel" id={uid} style={{ position: 'relative', display: 'none',marginBottom: '-36px', width: '98px',zIndex:'99999' }}
        //                             onClick={() => this.handlePasteClick(this.state.load.loadNum, uid)}>
        //                             <span className="react-contextmenu-item" >Paste Jump</span>
        //                         </div>
        //                     </div>
        //                 </div>
        //                 <div style={{ maxHeight: '70vh', overflowY: 'auto', overflowX: 'hidden' }} id={"centercard" + this.state.load.loadNum}>
        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {tandemUltraJumps}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row" >
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {wingSuitJumps}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {wingsuitCoachJumps}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row" >
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {highpulls}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {trackingJumps}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {tandemJumps}
        //                         </TransitionGroup>
        //                     </div>

        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {affJumps}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row">
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {solos}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row">
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {freeflyJumps}
        //                         </TransitionGroup>
        //                     </div>

        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {bellyJumpsSolo}
        //                         </TransitionGroup>
        //                     </div>

        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {coachJumps}
        //                         </TransitionGroup>
        //                     </div>

        //                     <div className="row">
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {bellyJumps}
        //                         </TransitionGroup>
        //                     </div>



        //                     <div className="row">
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {hopnpops}
        //                         </TransitionGroup>
        //                     </div>
        //                     <div className="row" style={{ pointerEvents: IsEventEnable }}>
        //                         <TransitionGroup style={{ width: '100%' }}>
        //                             {undecidedJumps}
        //                         </TransitionGroup>
        //                     </div>

        //                     {
        //                         this.state.creatingFunJump && !this.props.iscompleted ?
        //                             <CreateFunJumpCard load={this.props.load} disabled={this.state.load.closed} jumperOptions={jumperOptions} />
        //                             :
        //                             null
        //                     }
        //                 </div>
        //             </div>

        //             {
        //                 !this.props.iscompleted && !IsdisplayOnly ?
        //                     <div className="centerDivFooter" style={{ fontSize: "18px", background: backgroundColorFooter }}>
        //                         <button className="btn lightBlueButton jump-create" style={{ fontSize: "22px" }} onClick={() => this.createFunJump("centercard" + this.state.load.loadNum)} data-key={this.state.load.loadNum} type="submit" disabled={this.state.load.closed}
        //                             style={{ borderRadius: '100px', fontSize: '1.2rem !important' }}>
        //                             <i className="fa fa-plus" /> <strong>FUN JUMP</strong>
        //                         </button>

        //                     </div>
        //                     :
        //                     <div className="centerDivFooter" style={{ height: '70px' }}></div>
        //             }
        //         </div>
        //     </ReactCSSTransitionGroup>
        // </div>

        <div key={this.state.load.loadNum} className={"mainContainerHeight " + colsize + ' load-' + this.state.load.loadNum} style={{ padding: '0px !important' }} id={"Load_" + this.state.load.loadNum + "_Report"} >


          {window.ENV.tenant !== "perris" ? <span className="timeRemaining">
            {this.state.load.isPaused ? "PAUSED" :
              <React.Fragment>
                <Time command={"start"} startTime={this.state.load.timeRemaining} load={this.state.load} />
              </React.Fragment>}
          </span> : null}

          <ReactCSSTransitionGroup transitionName="load-manger" transitionAppear={true} transitionEnterTimeout={500} transitionAppearTimeout={500} transitionLeave={true} transitionLeaveTimeout={1000}>
            <div onContextMenu={(e) => this.handleClick(e, uid, "Load_" + this.state.load.loadNum + "_Report")}>
              <div className={
                !IsdisplayOnly ? `${this.props.iscompleted ? 'centerCardsDisplayOnly' : 'centerCards'}` : `centerCardsDisplayOnly`}
              >
                {/* <div className="centerDivHeading row" style={{ background: backgroundColorHeader }} >
                                    <div className="col-12" style={{ fontSize: '1.2rem !important' }}>
                                        <div style={{ fontSize: '24px' }} ><strong> <span style={{ fontSize: '34px' }}>LOAD {this.state.load.loadNum} </span>  - {this.state.load.plane.toUpperCase()}-{this.state.load.planeLoadNum}</strong></div>
                                        <span style={{ fontSize: '18px', backgroundColor: '#1b5ba1' }} className="badge">
                                            jumpers manifested: {this.state.load.totalJumpers} out of {this.state.load.capacity}
                                        </span>
                                        {
                                            this.props.iscompleted ? <span style={{ fontSize: '18px' }} className="badge">COMPLETED</span> : null
                                        }
                                        {
                                            !this.props.iscompleted && this.state.load.closed ? <span style={{ fontSize: '18px' }} className="badge">CLOSED</span> : null
                                        }
                                        {
                                            !this.props.iscompleted && this.state.load.gearUp ? <span className="badge" style={{ backgroundColor: '#464123', fontSize: '18px' }} >GEAR UP</span> : null
                                        }
                                        {
                                            !this.props.iscompleted && !this.state.load.gearUp && this.state.load.isNext ? <span className="badge" style={{ backgroundColor: '#008000', fontSize: '18px' }} >NEXT LOAD</span> : null
                                        }
                                        {
                                            !this.props.iscompleted && !this.state.load.gearUp && this.state.load.waitFuel ? <span className="badge" style={{ backgroundColor: '#464123', fontSize: '18px' }} >FUEL BEFORE</span> : null
                                        }
                                        {
                                            !this.props.iscompleted && this.state.load.reserved ? <span className="badge" style={{ backgroundColor: '#FFA500', fontSize: '18px' }} >RESERVED</span> : null
                                        }

                                    </div>
                                </div> */}
                <LoadHeader loadObj={this.state.load} isCompleted={this.props.iscompleted} loadsToShow={this.props.loadsToShow} />

                <div className="row" >
                  <div className="col-12">
                    <div className="react-contextmenu pastepanel" id={uid} style={{ position: 'relative', display: 'none', marginBottom: '-36px', width: '98px', zIndex: '99999' }}
                      onClick={() => this.handlePasteClick(this.state.load.loadNum, uid)}>
                      <span className="react-contextmenu-item" >Paste Jump</span>
                    </div>
                  </div>
                </div>

                <div className={`${centercard} ${this.state.toggleClass ? 'scrollUp' : ''}`}
                  id={centercard + this.state.load.loadNum}
                >
                  {
                    this.state.load.isWaitlist ?
                      <div className="row" >
                        <TransitionGroup style={{ width: this.props.iscompleted ? '96.5%' : '98%' }}>
                          {allFunJumps}
                        </TransitionGroup>
                      </div>
                      :
                      <React.Fragment>
                        <div className="row" style={{ pointerEvents: IsEventEnable }}>
                          <TransitionGroup style={{ width: '100%' }}>
                            <CSSTransition
                              key={0}
                              timeout={500}
                              classNames="fade"
                            >
                              <div id={0} key={0} className="col-12">

                                <RenderPilotCard
                                  history={this.props.history}
                                  id={"pilot" + 0}
                                  key={0}
                                  load={this.state.load}
                                  pilot={this.state.load.pilot}
                                  pilotPay={this.state.load.pilotPay}
                                  loadNum={this.state.load.loadNum}
                                  pilotOptions={pilotOptions}
                                  jumpType="pilot"
                                  price={this.state.load.pilotPay}
                                  isCompleted={this.props.iscompleted}
                                  handleJumperDrop={this.handleJumperDrop}
                                  handleTandemDrop={this.handleTandemDrop}
                                  loadsToShow={this.props.loadsToShow}
                                  fontSize={this.props.fontSize}
                                  columnsPerGroup={this.props.columnsPerGroup}
                                />
                              </div>
                            </CSSTransition>
                          </TransitionGroup>
                        </div>
                        <div
                          className="row"
                        >
                          <TransitionGroup style={{ width: "100%" }}>
                            {alljumps}
                          </TransitionGroup>
                        </div>
                      </React.Fragment>

                  }

                  {
                    this.state.creatingFunJump && !this.props.iscompleted ?
                      <CreateFunJumpCard
                        jumpType={this.state.funJumpType}
                        load={this.state.load}
                        activeJumperIdsOnLoad={this.state.load.activeJumperIds}
                        disabled={this.state.load.closed}
                      />
                      :
                      null
                  }
                  {
                    this.state.creatingTeamJump && !this.props.iscompleted ?
                      <CreateTeamJumpCard
                        jumpType={this.state.funJumpType}
                        load={this.state.load}
                        disabled={this.state.load.closed}
                        //jumperOptions={jumperOptions} 
                        teamsOptions={this.state.teamsOptions}
                        teams={this.state.teams}
                      />
                      :
                      null
                  }
                </div>
              </div>
              <LoadsFooter
                usingWaitlist={this.props.usingWaitlist}
                loadObj={this.state.load}
                isCompleted={this.props.iscompleted}
                IsdisplayOnly={IsdisplayOnly}
                toggleFooterClass={this.toggleFooterClass}
                toggleClass={this.state.toggleClass}
                createFunJump={this.createFunJump}
                createTeamJump={this.createTeamJump}
                disabled={this.props.disabled}
                backgroundColorFooter={backgroundColorFooter}
              />
            </div>
          </ReactCSSTransitionGroup>
        </div >

      );
    }
  }
}

//export default Load;
export default DropTarget('JUMP', loadTarget, collect)(Load);
